import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (event, sectionId) => {
    event.preventDefault();

    if (location.pathname !== '/') {
      navigate('/');

      window.setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 100);

      return;
    }

    document.getElementById(sectionId)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };

  return (
    <footer className="footer">
      <Link className="brand" to="/" aria-label="GEN IT SOLUTIONS INC home">
        <span className="brand-mark">G</span>
        <span>
          GEN IT <span className="brand-muted">SOLUTIONS INC</span>
        </span>
      </Link>

      <p>AI strategy, products, and automation.</p>

      <div className="footer-links">
        <a
          href="#services"
          onClick={(event) => scrollToSection(event, 'services')}
        >
          Services
        </a>
        <a
          href="#approach"
          onClick={(event) => scrollToSection(event, 'approach')}
        >
          Approach
        </a>
        <Link to="/privacy">Privacy Policy</Link>
        <a href="mailto:info@genitsolutions.us">Contact</a>
      </div>

      <span className="copyright">
        © {new Date().getFullYear()} GEN IT SOLUTIONS INC
      </span>
    </footer>
  );
}

export default Footer;